import { render, staticRenderFns } from "./MypageUpdate.vue?vue&type=template&id=15d50922&"
import script from "./MypageUpdate.vue?vue&type=script&lang=js&"
export * from "./MypageUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports